import React from 'react';
import { useNavigate } from 'react-router-dom';
import qs from 'query-string';
import { useStoreContext } from '../../factorys/useStoreContext';
import { IdentityContext } from '../../containers/App/identity.context';
import { hasBothTeacherAndTa } from '../../utils/teacherPortalView';

type TeacherPortalViewSwitchProps = {
  /** gradebook 页展示「切换为教师界面」；teacher 首页展示「切换为班主任界面」 */
  mode: 'gradebook' | 'teacher';
  className?: string;
};

export const TeacherPortalViewSwitch: React.FC<TeacherPortalViewSwitchProps> = ({
  mode,
  className,
}) => {
  const navigate = useNavigate();
  const { currentClassIdentities, currentClassId, setPortalView } =
    useStoreContext(IdentityContext);

  // 仅当当前班级同时是任课教师 + 班主任时显示切换入口
  if (!hasBothTeacherAndTa(currentClassIdentities)) {
    return null;
  }

  const switchToTeacherView = () => {
    setPortalView('teacher');
    navigate('/');
  };

  const switchToGradebookView = () => {
    setPortalView('gradebook');
    navigate(`/gradebook?${qs.stringify({ classId: currentClassId })}`);
  };

  const baseClass =
    className ??
    'text-[#797979] text-sm mt-2 max-w-[280px] leading-relaxed [word-break:keep-all]';

  if (mode === 'gradebook') {
    return (
      <p className={baseClass}>
        当前班主任也是任课老师，可以点击
        <button
          type="button"
          className="underline cursor-pointer bg-transparent border-0 p-0 text-inherit whitespace-nowrap"
          onClick={switchToTeacherView}
        >
          切换为教师界面
        </button>
      </p>
    );
  }

  return (
    <p className={baseClass}>
      当前任课老师也是班主任，可以点击
      <button
        type="button"
        className="underline cursor-pointer bg-transparent border-0 p-0 text-inherit whitespace-nowrap"
        onClick={switchToGradebookView}
      >
        切换为班主任界面
      </button>
    </p>
  );
};
